import React from "react";
import PlanCard from "../PlanCard";
import { useFeatureList, usePlansList } from "hooks/api/usePlans";
import Skeleton from "components/BaseWidgets/skeleton";
import { getFormattedPersonalizedPlans } from "components/Plans/utils";

function PersonalizedTab({ onOk, isPending }) {
  const { data, isLoading } = usePlansList({ plan_type: 2,see_all: true });
  const { data: featureData = {} } = useFeatureList(2);

  const personalizedPlans = data?.data?.plan_data || [];
  const allFeatures = featureData?.plan_feature || [];

  const formattedPlans = getFormattedPersonalizedPlans(
    personalizedPlans,
    allFeatures,
  );

  return (
    <div className="mt-6 flex flex-col gap-16 personalize-plans-list">
      <div className="flex flex-col gap-2 items-center">
        <h1 className="main-title">Personalized assist subscription plan</h1>
        <p className="main-description tab-description text-center">
          Find your perfect match with personalized assist, a premium service
          designed for those who seek expert guidance in their matchmaking
          journey. Let our dedicated relationship experts assist you in finding
          the most compatible partner based on your preferences.
        </p>
      </div>

      {isLoading ? (
        <Skeleton count={3} height={300} width="100%" label={false} />
      ) : formattedPlans.length > 0 ? (
        <div className="flex items-stretch gap-8 justify-center flex-wrap">
          {formattedPlans.map((plan, i) => (
            <PlanCard
              isPopular={plan?.is_popular}
              isPending={isPending}
              key={i}
              data={plan}
              onOk={() => onOk(plan)}
            />
          ))}
        </div>
      ) : (
        <p className="text-center text-gray-500 font-body-lg">
          No personalized plans available at the moment.
        </p>
      )}
    </div>
  );
}

export default PersonalizedTab;
